import type { FC } from 'react';
import { extendAnalyticsData, useAccessCookie, useLineBehaviorV2 } from '@mwl/core-lib';
import SportFieldIcon from '@public/assets/sport/icons/field.svg';
import StreamIcon from '@public/assets/sport/icons/stream.svg';
import { Button } from '@/components/Button/Button';
import { lineRowLinkDataAttributes, routes } from '@/constants';
import type { LineRowScoresProps } from '@/types';
import styles from './LineRowScores.module.scss';
export const LineRowScores: FC<LineRowScoresProps> = ({
  line,
  analytics
}) => {
  const {
    stage
  } = line;
  const {
    hasWidgets,
    hasTranslation,
    lineHref,
    singleCompetitor
  } = useLineBehaviorV2({
    line,
    routes
  });
  const hasWidgetsAccess = useAccessCookie('widgets');
  return <div className={styles.root} data-sentry-component="LineRowScores" data-sentry-source-file="LineRowScores.tsx">
      {hasWidgets || hasTranslation ? <Button className={styles.widgets} as="link" href={lineHref} variant="text" analytics={extendAnalyticsData(analytics?.widgets, {
      href: lineHref,
      line_id: line.id
    })}>
          <div className={styles.widgetsIcons}>
            {hasWidgets && stage === 'LIVE' && hasWidgetsAccess && <SportFieldIcon className={styles.indicatorIcon} />}
            {hasTranslation && <StreamIcon className={cn(styles.indicatorIcon, {
          [styles.indicatorPregameIcon]: stage === 'PREGAME'
        })} />}
          </div>
        </Button> : <div className={styles.widgetsEmpty} {...lineRowLinkDataAttributes} />}
      {!singleCompetitor && <>
          <span {...lineRowLinkDataAttributes} className={styles.score}>
            {line.stats?.competitorStats?.[0].totalScore}
          </span>
          <span {...lineRowLinkDataAttributes} className={styles.score}>
            {line.stats?.competitorStats?.[1].totalScore}
          </span>
        </>}
    </div>;
};